import React, { Component } from "react";
import RegStepUserData from "../../components/auth/RegStepUserData";
import RegStepCode from "../../components/auth/RegStepCode";
import RegStepUserDataList from "../../components/auth/RegStepUserDataList";
import { connect } from "react-redux";
import RegEcp from "../../components/auth/RegEcp";
import { checkSignatureAction, getCerfInfoAction, getUserCertificatesAction, signCertificateAction } from "../../actions/diadocAction";
import { regByDs, regShowData } from "../../actions/reg";
import { authByDs } from "../../actions/auth";
import closeIcon from '../../../img/icons/X.svg'
import { toBase64 } from "../../tools/tools";
import { withRouter } from "react-router-dom";
import Form from "../../components/common/form/Form";


class RegistrationByDsContainer extends Component {
    constructor(props) {
        super(props)
        const { selectedCerf } = this.props.diadocState
        this.state = {
            fieldsRegStep4: {
                last_name: {
                    type: 'text',
                    label: "Фамилия",
                    name: "lastName",
                    value: selectedCerf && selectedCerf.info && selectedCerf.info.last_name || '',
                    required: true,
                    error: '',
                    disabled: true,
                    // mask: nameMask,
                    ref: (input) => {
                        this.lastNameInput = input;
                    }
                },
                first_name: {
                    type: 'text',
                    label: "Имя",
                    name: "firstName",
                    value: selectedCerf && selectedCerf.info && selectedCerf.info.first_name || "",
                    required: true,
                    error: '',
                    disabled: true,
                    // mask: nameMask,
                    ref: (input) => {
                        this.firstNameInput = input;
                    }
                },
                second_name: {
                    type: 'text',
                    label: "Отчество",
                    name: "secondName",
                    value: selectedCerf && selectedCerf.info && selectedCerf.info.second_name || "",
                    required: true,
                    disabled: true,
                    error: '',
                    // mask: nameMask,
                    ref: (input) => {
                        this.secondNameInput = input;
                    }
                },
                inn: {
                    type: "text",
                    label: "ИНН компании",
                    placeholder: "Введите ИНН компании",
                    value: selectedCerf && selectedCerf.info && selectedCerf.info.inn || "",
                    required: true,
                    disabled: true,
                    error: '',
                },
                short_name: {
                    type: 'text',
                    label: "Краткое наименование компании",
                    name: "companyDescriptionName",
                    disabled: true,
                    value: selectedCerf && selectedCerf.info && selectedCerf.info.short_name,
                    error: '',
                    ref: (input) => {
                        this.companyDescriptionInput = input;
                    }
                },
            },
            fieldsEc: {
                digitalSignature: {
                    type: 'select-diadoc',
                    label: "Выберите электронную подпись",
                    placeholder: "Выберите подпись",
                    name: "ecp",
                    value: "",
                    options: [],
                    // required: true,
                    error: '',
                },
            },
            agreeModal: false,
            disabled: false,
        }
    }

    componentDidUpdate(prevProps) {

        const { diadocState } = this.props;
        const { selectedCerf } = this.props.diadocState
        let data

        if (prevProps.diadocState !== diadocState) {
            this.setState(prevState => ({
                fieldsEc: {
                    ...prevState.fieldsEc,
                    digitalSignature: {
                        ...prevState.fieldsEc.digitalSignature,
                        options: this.props.diadocState.userCertificate
                    }
                }
            }));
        }

        if (diadocState !== prevProps.diadocState) {
            if (selectedCerf.info) {

                data = {
                    last_name: selectedCerf && selectedCerf.info.last_name,
                    first_name: selectedCerf && selectedCerf.info.first_name,
                    second_name: selectedCerf && selectedCerf.info.second_name,
                    inn: selectedCerf && selectedCerf.info.inn,
                    short_name: selectedCerf && selectedCerf.info.short_name
                }
                this.setState(prevState => ({
                    fieldsRegStep4: {
                        ...prevState.fieldsRegStep4,
                        last_name: {
                            ...prevState.fieldsRegStep4.last_name,
                            value: data.last_name
                        },
                        first_name: {
                            ...prevState.fieldsRegStep4.first_name,
                            value: data.first_name
                        },
                        second_name: {
                            ...prevState.fieldsRegStep4.second_name,
                            value: data.second_name
                        },
                        inn: {
                            ...prevState.fieldsRegStep4.inn,
                            value: data.inn
                        },
                        short_name: {
                            ...prevState.fieldsRegStep4.short_name,
                            value: data.short_name
                        }

                    }
                }));
            }
        }

    }

    componentWillUnmount() {
        this.props.regByDsAct(false)
        this.props.authByDsAct(false)
        this.props.ChangeDsStep(0)
        localStorage.removeItem('regByDs')
    }


    onSelecSignature = (attribute, value) => {
        this.setState(prevState => ({
            fieldsEc: {
                ...prevState.fieldsEc,
                digitalSignature: {
                    ...prevState.fieldsEc.digitalSignature,
                    value: value
                }
            }
        }));
        this.props.getCerfInfoAction(value)


    };

    showData = () => {
        const data = {
            first_name: this.state.fieldsRegStep4.first_name.value,
            last_name: this.state.fieldsRegStep4.last_name.value,
            second_name: this.state.fieldsRegStep4.second_name.value,
            email: this.props.fieldsRegStep1.email.value,
            inn: this.state.fieldsRegStep4.inn.value,
            short_name: this.state.fieldsRegStep4.short_name.value,
            // regionName: this.props.fieldsRegion.region_id.value,
            phone_number: this.props.fieldsRegStep1.phone_number.value
        }
        this.props.onRegShowData(data)
        this.props.checkSms()
    }

    endReg = () => {
        const cerfInfo = JSON.stringify({
            requestTime: new Date(Date.now()),
            phone: '+' + this.props.fieldsRegStep1.phone_number.value.replace(/\D/gi, ''),
            email: this.props.fieldsRegStep1.email.value,
        })
        const base64String = toBase64(cerfInfo);
        const data = {
            first_name: this.state.fieldsRegStep4.first_name.value,
            last_name: this.state.fieldsRegStep4.last_name.value,
            second_name: this.state.fieldsRegStep4.second_name.value,
            email: this.props.fieldsRegStep1.email.value,
            inn: this.state.fieldsRegStep4.inn.value,
            short_name: this.state.fieldsRegStep4.short_name.value,
            phone_number: this.props.fieldsRegStep1.phone_number.value,
            requestBody: base64String
        }
        this.props.onRegSendData(data)

    }

    onRegByEcpSubmit = () => {
        this.setState(prevState => ({
            disabled: true,
        }))
        const cerfInfo = JSON.stringify({ requestTime: new Date(Date.now()) })
        const base64String = toBase64(cerfInfo);
        this.props.signCertificateAction(this.state.fieldsEc.digitalSignature.value, base64String)
        this.props.checkSignature(cerfInfo)
    }

    closeAgreeModal = () => {
        this.setState({ agreeModal: false })
    }

    openAgreeModal = () => {
        this.setState({ agreeModal: true })
    }

    closeAndGoToRecovery = (e) => {
        e.preventDefault()
        if (this.props.authByDs) this.props.authByDsAct(false)
        this.props.regByDsAct(false)
        this.props.history.push('/recovery')
    }

    hanldeClose = () => {
        if (this.props.authByDs) this.props.authByDsAct(false)
        if (this.props.regByDs) this.props.regByDsAct(false)
        if (this.props.recByDs) this.props.handleCloseRecDs()
        this.props.history.push('/login', { switcher: this.props.isRegPage })
    }

    chooseSignature = () => {
        this.props.ChangeDsStep(0)
        this.props.getUserCertificatesAction()
        this.props.validationError()
    }

    backFromCodeStep = () => {
        this.props.ChangeDsStep(1)
        this.props.cleanPrevEmail()
    }

    render() {
        const { isRegPage, privatePolicyLink, emailField } = this.props
        const { stepDs } = this.props.diadocState
        const { regByDs, tries_more, sendRequest } = this.props.regState
        const { agreeModal, disabled } = this.state

         const { reg1Errors = {} } = this.props.regState;
        const codeStr = String(reg1Errors.code || "");
        const isCodeMinus11 = codeStr.includes("-11");
        const isUserExists = reg1Errors.code === "user_exists";
    
        const titleText = isCodeMinus11
            ? "Пользователь с такими данными уже существует"
            : "Что-то пошло не так...";
    
        const backBtnClass = isCodeMinus11
            ? "reg_by_ds_register_btn code"
            : "repeat_another_btn";
    
        const recoveryBtnClass = isCodeMinus11
            ? "repeat_another_btn code"
            : "reg_by_ds_register_btn";
    
        const recoveryBtnText = isUserExists
            ? "Восстановить пароль"
            : "Восстановить доступ";

        return <div>
            {stepDs === 0 ?
                <RegEcp
                    getUserCertificatesAction={this.props.getUserCertificatesAction}
                    getCerfInfoAction={this.props.getCerfInfoAction}
                    onSubmit={this.onRegByEcpSubmit}
                    fieldsEc={this.state.fieldsEc}
                    onSelecSignature={this.onSelecSignature}
                    stepDs={stepDs}
                    diadocState={this.props.diadocState}
                    regByDsAct={this.props.regByDsAct}
                    isRegPage={isRegPage}
                    regState={this.props.regState}
                    disabled={disabled}
                />
                :
                agreeModal ?
                    <div className='auth__form__ecp__box agree'>
                        <div className='icon__block' onClick={this.closeAgreeModal}>
                            <img src={closeIcon} />
                        </div>
                        <div
                            className="auth__form__ecp agree"
                        >
                            <div className="main-modal_adapt-default">
                                <p className="main-modal__title reg">{this.props.context.translate('Согласие')}</p>
                                <div className="reg-modal-text">
                                    Я даю свое согласие Обществу с ограниченной ответственностью «ДельтаЛизинг»<br />(ООО «ДельтаЛизинг»), адрес: 690091, г. Владивосток, пер. Ланинский, зд.2, на смешанную (автоматизированную и неавтоматизированную) обработку, а именно: сбор, запись, систематизацию, хранение, уточнение (обновление, изменение), использование, обезличивание, блокирование, удаление, уничтожение, следующих персональных данных: фамилия, имя, отчество; номер телефона; адрес электронной почты; дата и время осуществления доступа к сайту и установленным на нем сервисам.<br /><br />
                                    Согласие на обработку персональных данных предоставляется для целей: предоставления доступа к сервису Онлайн-Офис DeltaЛизинг и выполнения роли пользователя в нем согласно установленным правилам использования сервиса, а также установления и поддержания делового общения с Оператором, информирования об оказываемых Оператором услугах.<br /><br />
                                    Согласие действует до отмены доступа к сервису Онлайн-Офис DeltaЛизинг. Мне известно, что согласие может быть отозвано в любой момент путем направления обращения в письменной форме по указанному выше адресу Оператора либо по электронному адресу: <a href="mailto:data.privacy.ru@deltaleasing.ru">data.privacy.ru@deltaleasing.ru</a><br /><br />
                                    Мне понятно, что отзыв согласия или прекращение предусмотренной согласием обработки персональных по моему требованию могут привести к невозможности достижения предусмотренных согласием целей обработки персональных данных, в том числе к невозможности предоставления доступа к сервису Онлайн-Офис DeltaЛизинг.
                                </div>
                            </div>
                        </div>

                    </div>
                    : this.props.regState.dsValidationError ?
                        <div className='auth__form__ecp__box'>
                            <div className='icon__block' onClick={this.hanldeClose}>
                                <img src={closeIcon} />
                            </div>
                            <div className="auth__form__ecp">
                            <h3>{titleText}</h3>
            <Form validate={true}>
                <p>{reg1Errors.message}</p>
                <div className="form__buttons_error">
                    <button
                        onClick={this.props.validationError}
                        className={backBtnClass}
                    >
                        Назад
                    </button>
                    <button
                        type="button"
                        onClick={this.closeAndGoToRecovery}
                        className={recoveryBtnClass}
                    >
                        {recoveryBtnText}
                    </button>
                </div>
                                </Form>
                            </div>

                        </div>
                        :
                        <div className="reg__container">
                            <div className="auth__form__reg">
                                <h3 className="reg__title">Регистрация</h3>
                                {stepDs === 1 &&
                                    <RegStepUserData
                                        context={this.props.context}
                                        regState={this.props.regState}
                                        checkCompanyData={this.props.checkPhone}
                                        endReg={this.endReg}
                                        fieldsRegStep1={this.props.fieldsRegStep1}
                                        fieldsRegStep4={this.state.fieldsRegStep4}
                                        regionId={this.props.regionId}
                                        personal={this.props.personal}
                                        onlineOfficeAgree={this.props.onlineOfficeAgree}
                                        renderFields={this.props.renderFields}
                                        sendRequest={sendRequest}
                                        isValid={this.props.isValid}
                                        openAgreeModal={this.openAgreeModal}
                                        regByDs={regByDs}
                                        // fieldsRegion={this.props.fieldsRegion}
                                        privatePolicyLink={privatePolicyLink}
                                        emailField={emailField}
                                    />
                                }
                                {stepDs === 2 &&
                                    <RegStepCode
                                        checkSms={this.showData}
                                        renderFields={this.props.renderFields}
                                        fieldsRegStep2={this.props.fieldsRegStep2}
                                        ecpStep={regByDs}
                                        regState={this.props.regState}
                                        onRepeatCodeRequest={this.props.onRepeatCodeRequest}
                                        isValid={this.props.isValid}
                                        tries_more={tries_more}
                                        time={this.props.time}
                                        context={this.props.context}
                                        back={this.backFromCodeStep}
                                    />
                                }
                                {stepDs === 3 &&
                                    <RegStepUserDataList
                                        context={this.props.context}
                                        regState={this.props.regState}
                                        fieldsRegStep3={this.state.fieldsRegStep4}
                                        fieldsRegStep1={this.props.fieldsRegStep1}
                                        onRegChangeData={this.props.onRegChangeData}
                                        regByDs={regByDs}
                                        endReg={this.endReg}
                                    />}
                            </div>
                        </div>
            }
        </div>
    }
}

export default withRouter(connect(
    state => ({
    }),
    (dispatch) => {
        return {
            signCertificateAction: (thumbprint, contentPdf) => dispatch(signCertificateAction(thumbprint, contentPdf)),
            checkSignature: (data) => dispatch(checkSignatureAction(data)),
            ChangeDsStep: (step) => dispatch({ type: 'CHANGE_STEP_DS', step }),
            onRegShowData: (data) => dispatch(regShowData(data)),
            regByDsAct: (value) => dispatch(regByDs(value)),
            authByDsAct: (value) => dispatch(authByDs(value)),
            validationError: () => dispatch({ type: 'DS_VALIDATION_FALSE' }),
            getUserCertificatesAction: () => dispatch(getUserCertificatesAction()),
            getCerfInfoAction: (thumbprint) => dispatch(getCerfInfoAction(thumbprint)),
        }
    }
)(RegistrationByDsContainer));